"use client";

import Image from "next/image";
import "./FeatureHighlightSection.scss";
import { Col, Container, Row } from "react-bootstrap";

const FeatureHighlightSection = ({
  title,
  highlightTitle,
  description,
  features = [],
  className = "",
}) => {
  const renderTitle = () => {
    if (!title) return null;

    if (highlightTitle) {
      return (
        <>
          {title}{" "}
          <span className="highlight-title">{highlightTitle}</span>
        </>
      );
    }

    const match = title.match(/"(.*?)"/);

    if (match) {
      const beforeText = title.slice(0, match.index);
      const highlightedText = match[1];
      const afterText = title.slice(match.index + match[0].length);

      return (
        <>
          {beforeText}
          <span className="highlight-title">{highlightedText}</span>
          {afterText}
        </>
      );
    }

    return title;
  };

  return (
    <section className={`feature-highlight-section ${className}`}>
      <Container>
        {title && (
          <h2 className="section-title">
            {renderTitle()}
          </h2>
        )}

        {description && <p className="section-description">{description}</p>}

        <Row>
          <Col lg={12}>
            <div className="features-wrapper">
              <div className="feature-list">
                {features.map((item) => (
                  <div key={item.id} className="feature-row">
                    <div className="left-content">
                      <div className="feature-icon">
                        <Image
                          src={item.icon?.src || item.icon}
                          alt={item.title}
                          width={40}
                          height={40}
                        />
                      </div>

                      <div className="text-content">
                        <p className="feature-title">{item.title}</p>

                        {item.description && (
                          <div className="description-wrapper">
                            <span className="feature-description">
                              {item.description}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {item.image && (
                      <div className="feature-image-container">
                        <Image
                          src={item.image}
                          alt={item.title}
                          width={140}
                          height={90}
                          className="hover-zoom-img"
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FeatureHighlightSection;